var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStopwatch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 2C15 1.44772 14.5523 1 14 1H10C9.44772 1 9 1.44771 9 2C9 2.55228 9.44772 3 10 3L11 3V4.05493C6.50005 4.55237 3 8.36745 3 13C3 17.9706 7.02944 22 12 22C16.9706 22 21 17.9706 21 13C21 8.36745 17.5 4.55237 13 4.05493V3H14C14.5523 3 15 2.55228 15 2ZM12 6C8.13401 6 5 9.13401 5 13C5 16.866 8.13401 20 12 20C15.866 20 19 16.866 19 13C19 9.13401 15.866 6 12 6ZM12 13H18C18 9.68629 15.3137 7 12 7L12 13ZM21.2071 6.70708C21.5976 6.31655 21.5976 5.68339 21.2071 5.29286L19.7071 3.79286C19.3166 3.40234 18.6834 3.40234 18.2929 3.79286C17.9024 4.18339 17.9024 4.81655 18.2929 5.20708L19.7929 6.70708C20.1834 7.0976 20.8166 7.0976 21.2071 6.70708ZM2.79289 5.29286C2.40237 5.68339 2.40237 6.31655 2.79289 6.70708C3.18342 7.0976 3.81658 7.0976 4.20711 6.70708L5.70711 5.20708C6.09763 4.81655 6.09763 4.18339 5.70711 3.79286C5.31658 3.40234 4.68342 3.40234 4.29289 3.79286L2.79289 5.29286Z",
    fill: "#001A39"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStopwatch);
export default __webpack_public_path__ + "static/media/Stopwatch.7ae3f241d5edad0b3b3d410546c67237.svg";
export { ForwardRef as ReactComponent };